import { useEffect, useState, useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setPaypalError, taxUnavailable } from 'State/Checkout/CheckoutActions';
import { createPayPalOrder, getSubscriptionOrder } from 'Api/PayPal';
import { trackPaymentAction } from 'Utils/PaymentMethods';

export const usePayPal = () => {
  const dispatch = useDispatch();
  const [state, setState] = useState(false);
  const { usePayPalPayments = false } = useSelector((s) => s.appConfig.defaultConfig);
  const purchaseMode = useSelector((s) => s.purchaseMode);
  const promoCode = useSelector((s) => s.promoCode);
  const checkout = useSelector((s) => s.checkout);
  const plans = useSelector((s) => s.plans);

  const createOrder = useCallback(
    (order) => {
      dispatch(taxUnavailable());
      return createPayPalOrder(order).catch((error) => dispatch(setPaypalError(error.message)));
    },
    [dispatch]
  );

  const createAuthOrder = useCallback(() => {
    const order = { value: 100 };
    return createOrder(order);
  }, [createOrder]);

  const createSubscriptionOrder = useCallback(() => {
    if (!plans.isPlanSelected) {
      return Promise.reject(Error('Plan is not selected'));
    }
    trackPaymentAction('paypal');
    const order = getSubscriptionOrder({ plans, promoCode, checkout, purchaseMode });
    return createOrder(order);
  }, [createOrder, plans, promoCode, checkout, purchaseMode]);

  const actions = useMemo(
    () => ({ createAuthOrder, createSubscriptionOrder }),
    [createAuthOrder, createSubscriptionOrder]
  );

  useEffect(() => {
    const isPayPalEnabled = usePayPalPayments;
    setState(isPayPalEnabled);
  }, [usePayPalPayments]);

  return [state, actions];
};
